<template>

  <div  class="card__body-components">
    <div  v-for="supplement in supplements" style="display: flex;
    flex-direction: column;
   ">
      <div  v-for="supplementProduct in supplement.products">
        <div style="margin-bottom: 10px" class="card__components-item" v-if="isSelected(supplement.product_option_id, supplementProduct.product_id)">
          <div class="card__components-left">
             <div class="card__components-name">{{ supplementProduct.name }}</div>
            <div class="card__components-type">{{ supplement.name }}</div>
          </div>
          <div class="card__components-right">
            <div class="card__components-price">{{ supplementProduct.price }}</div>
            <div class="card__components-weight" v-if="supplementProduct.nutrition?.weight_formatted">{{ supplementProduct.nutrition.weight_formatted }} </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="optionsList.length === 0" style="display: block" class="card__body-empty">Выберите составляющие <br> для бургера</div>

</template>
<script>
import TheProductImage from "@/components/element/TheProductImage.vue";
import ProductImageType from "@/enum/ProductImageType.js";
import * as events from "events";
import TheSpinner from "@/components/TheSpinner.vue";

export default {
  name: 'TheProductSupplementsSelectedList',
  computed: {
    events() {
      return events
    },
    ProductImageType() {
      return ProductImageType
    },

  },
  components: {TheSpinner, TheProductImage},
  data() {
    return {
      supplements: null,
      products: []
    }
  },
  mounted() {
    this.supplements = this.product.options.filter((option) => option.type === 'product');
  },

  props: {
    product: {
      type: Object,
      require: true,
    },
    optionsList: {
      type: Array,
      require: true,
    },
  },
  methods:{
    isSelected(key, product_id) {
      let found = false;
      this.optionsList.forEach((entry) => {
        if (entry.hasOwnProperty(key) &&  entry[key].includes(''+product_id) ) {
          found = true;
        }
      });
      return found;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>